<app-breadcrumb [master]="'Administracja'" [parentName]="'Adresy'"  [name]="'Lista importów'"></app-breadcrumb>
<div class="import-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm">
  </form>

  <div class="import-list-buttons"  fxLayout="row" fxLayoutAlign="space-between" >

    <div *ngIf="(userPermissions | async).address_database.create">
      <button   mat-raised-button color="primary" (click)="import()" ><mat-icon>add</mat-icon>  Zaimportuj</button>
    </div>

  </div>
  <table mat-table [dataSource]="imports">


    <ng-container matColumnDef="changeToRegistered" >
      <th mat-header-cell *matHeaderCellDef style="text-align: center"> Import ulic
      <td mat-cell *matCellDef="let element" style="text-align: center">
        {{element.streetImport ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data importu </th>
      <td mat-cell *matCellDef="let element">
        {{element.createdAt | date:'y-MM-dd HH:mm'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef> Nazwa pliku  </th>
      <td mat-cell *matCellDef="let element">
        {{element.fileName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <div class="circular-image">
            <img class="circular-image small-avatar import-list-avatar"
                 [src]="'/rest/sso/api/user/' + element.createdBy.uuid + '/avatar'" (error)="onImgError($event)"
                 alt="Zdjęcie"/>
          </div>
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName}} {{element.createdBy.lastName}}</a>
        </ng-container>
        <ng-container *ngIf="!element.createdBy">
          System
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status importu </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="element.status" mat-raised-button [ngClass]="element.status.color + '-button'">
          {{element.status.name}}
          <ng-container *ngIf="element.status.key === IMPORT_STATUS_IN_PROGRESS">
            ({{element.progress}}%)
          </ng-container>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">

        <button  *ngIf="element.status.key !== IMPORT_STATUS_IN_PROGRESS" [disabled]="!(userPermissions | async).address_database.admin_root" (click)="delete(element)" mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
